define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/dateUtils", "../../utils/kendoUtils", "../../models/UserContext", "../../models/CustomerModel", "../../models/CustomerPlanItemModel", "../../models/CalcRatesModel", "../../models/BulkEditCustomerModel", "../../models/BulkEditCustomerMemberModel", "../../utils/LookupDataSources"], function (require, exports, $, ko, log, urls_1, tools, DateUtils, KendoUtils, UserContext, CustomerModel, CustomerPlanItemModel, CalcRatesModel, BulkEditCustomerModel, BulkEditCustomerMemberModel, LookupDataSources) {
    "use strict";
    var CustomerActions = /** @class */ (function () {
        function CustomerActions() {
            this.userCanViewBilling = ko.observable(UserContext.hasAccess("Admin,Billing.View"));
            this.userCanEditBilling = ko.observable(UserContext.hasAccess("Admin,Billing.Edit"));
            this.bulkEditCustomerModel = ko.observable(new BulkEditCustomerModel());
            this.bulkEditCustomerMemberModel = ko.observable(new BulkEditCustomerMemberModel());
            this.editModel = ko.observable(new CustomerModel());
            //editPlanModel = ko.observable(new ChangeCustomerPlanModel());
            this.editPlanItemModel = ko.observable(new CustomerPlanItemModel());
            this.calcRatesModel = ko.observable(new CalcRatesModel());
        }
        CustomerActions.prototype.editCustomer = function (customerId, customerName) {
            var self = this;
            var title = "Add New Customer";
            if ($.isNumeric(customerId) && customerName) {
                title = "Edit " + customerName + " Details";
            }
            tools.editModal({
                title: title,
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    //validate form
                    if (!self.editModel().Name()) {
                        tools.error("Customer Name is required");
                        return;
                    }
                    if (self.editModel().Tax1Name() && self.editModel().Tax2Name() &&
                        self.editModel().Tax1Name() === self.editModel().Tax2Name()) {
                        tools.error("Customer Tax 1 and Tax 2 can not be the same");
                        return;
                    }
                    if (!self.editModel().CustomerTypeId()) {
                        tools.error("Customer Type is a required field");
                        return;
                    }
                    self.editModel().Domain(self.editModel().SubDomain() + self.editModel().MainDomain());
                    $(event.currentTarget).button("loading");
                    self.saveCustomer(event.currentTarget, modal);
                },
                opened: function (modal) {
                    var getModelCall = null;
                    if ($.isNumeric(customerId)) {
                        getModelCall = tools.ajaxGet({
                            url: urls_1.urls.customerGetCustomerById,
                            data: { id: customerId },
                            success: function (result) {
                                if (result.Success) {
                                    self.editModel(new CustomerModel(result.Data));
                                }
                                else {
                                    log.error(result.Error);
                                }
                            }
                        });
                    }
                    else {
                        self.editModel(new CustomerModel());
                    }
                    // Get lookup data:
                    var getLookupData = tools.ajaxGet({
                        url: urls_1.urls.customerGetLookupData,
                        data: { customerId: customerId },
                        success: function (data) {
                            if (data.Success) {
                                self.lookupLists = data.Data.lookupLists;
                            }
                            else {
                                log.error(data.Error);
                            }
                        }
                    });
                    $.when(getLookupData, getModelCall).done(function () {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'customer-edit-template', data: editModel }\"></div>");
                        if (!$.isNumeric(customerId)) {
                            self.editModel().Tax2Name(self.lookupLists.DefaultTax2Name);
                        }
                        ko.applyBindings(self, modal);
                    });
                }
            });
        };
        CustomerActions.prototype.saveCustomer = function (btn, modal) {
            var self = this;
            var obj = ko.mapping.toJS(self.editModel);
            obj["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/customers/savecustomer",
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    if (self.saveCustomerCallback) {
                        self.saveCustomerCallback(result.Data);
                    }
                    $(modal).modal("hide");
                    return;
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        CustomerActions.prototype.removeCustomerConfirm = function (customerId) {
            var self = this;
            tools.confirmModal({
                title: "Remove Customer",
                text: "Are you sure you want to Remove Customer?",
                buttonTitle: "Remove",
                type: "info",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                self.removeCustomer(customerId);
            });
        };
        CustomerActions.prototype.removeCustomer = function (customerId) {
            var self = this;
            var data = {
                id: customerId
            };
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/Customers/DeleteCustomerConfirmed",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Customer Removed successfully");
                    if (self.removeCustomerCallback) {
                        self.removeCustomerCallback();
                    }
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                //btn.button("reset");
            });
        };
        CustomerActions.prototype.deletePlanItemConfirm = function (planItemId) {
            var self = this;
            tools.confirmModal({
                title: "Delete Plan Item",
                text: "Are you sure you want to delete Plan Item?",
                buttonTitle: "Delete",
                type: "danger",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                self.deletePlanItem(planItemId);
            });
        };
        CustomerActions.prototype.deletePlanItem = function (planItemId) {
            var self = this;
            var data = {
                id: planItemId
            };
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/CustomerPlans/DeletePlanItemConfirmed",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Plan Item deleted successfully");
                    if (self.saveCustomerPlanCallback) {
                        self.saveCustomerPlanCallback(result.Data);
                    }
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                //btn.button("reset");
            });
        };
        CustomerActions.prototype.editPlanItem = function (planId, planItemId, customerId) {
            var self = this;
            var title = "Add New Plan Item";
            if (!isNaN(planItemId)) {
                title = "Edit Plan Item";
            }
            tools.editModal({
                title: title,
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    //validate form
                    if (!self.editPlanItemModel().Name()) {
                        tools.error("Plan Item Name is required");
                        return;
                    }
                    if (self.multipleCallTypesSelector.value().length === 0) {
                        tools.error("Call Type is required");
                        return;
                    }
                    if (!self.editPlanItemModel().RateType()) {
                        tools.error("Rate Type is required");
                        return;
                    }
                    $(event.currentTarget).button("loading");
                    self.savePlanItem(event.currentTarget, modal);
                },
                opened: function (modal) {
                    var getLookupData = tools.ajaxGet({
                        url: "/Plan/GetLookupData",
                        success: function (data) {
                            if (data.Success) {
                                self.lookupLists = data.Data.lookupLists;
                            }
                            else {
                                log.error(data.Error);
                            }
                        }
                    });
                    var getModelCall = null;
                    if (!isNaN(planItemId)) {
                        getModelCall = tools.ajaxGet({
                            url: "/CustomerPlans/GetPlanItemById",
                            data: { id: planItemId },
                            success: function (result) {
                                if (result.Success) {
                                    self.editPlanItemModel(new CustomerPlanItemModel(result.Data));
                                }
                                else {
                                    log.error(result.Error);
                                }
                            }
                        });
                    }
                    else {
                        self.editPlanItemModel(new CustomerPlanItemModel());
                        self.editPlanItemModel().CustomerCallPlanId(planId);
                        self.editPlanItemModel().CustomerId(customerId);
                    }
                    $.when(getModelCall, getLookupData).done(function () {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'plan-item-edit-template', data: editPlanItemModel }\"></div>");
                        ko.applyBindings(self, modal);
                        self.multipleCallTypesSelector = $("#callTypes", modal).kendoMultiSelect({
                            autoBind: false,
                            valuePrimitive: true,
                            filter: "contains",
                            placeholder: "Select call types...",
                            dataTextField: "Text",
                            dataValueField: "Value",
                            autoClose: false,
                            dataSource: {
                                data: self.lookupLists.CallTypes
                            }
                        }).data("kendoMultiSelect");
                        self.multipleCallTypesSelector.value(self.editPlanItemModel().CallTypes());
                        self.multipleAdditionalCallTypesSelector = $("#additionalCallTypes", modal).kendoMultiSelect({
                            autoBind: false,
                            valuePrimitive: true,
                            filter: "contains",
                            placeholder: "Select call types...",
                            dataTextField: "Text",
                            dataValueField: "Value",
                            autoClose: false,
                            dataSource: {
                                data: self.lookupLists.CallTypes
                            }
                        }).data("kendoMultiSelect");
                        self.multipleAdditionalCallTypesSelector.value(self.editPlanItemModel().AdditionalCallTypes());
                    });
                }
            });
        };
        CustomerActions.prototype.savePlanItem = function (btn, modal) {
            var self = this;
            var obj = ko.mapping.toJS(self.editPlanItemModel);
            obj.CallTypesStr = self.multipleCallTypesSelector.value().join();
            obj.AdditionalCallTypesStr = self.multipleAdditionalCallTypesSelector.value().join();
            obj["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/CustomerPlans/SavePlanItem",
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    if (self.saveCustomerPlanCallback) {
                        self.saveCustomerPlanCallback(result.Data);
                    }
                    $(modal).modal("hide");
                    return;
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        CustomerActions.prototype.openCalculateRates = function (customerId) {
            var self = this;
            var title = "Calculate Phone Calls Rates";
            self.calcRatesModel(new CalcRatesModel());
            self.calcRatesModel().customerId(customerId);
            tools.editModal({
                title: title,
                buttonTitle: "Calculate",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    $(event.currentTarget).button("loading");
                    self.calculateRates(event.currentTarget, modal);
                },
                opened: function (modal) {
                    $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'calc-rates-template', data: calcRatesModel }\"></div>");
                    ko.applyBindings(self, modal);
                }
            });
        };
        CustomerActions.prototype.calculateRates = function (btn, modal) {
            var self = this;
            var obj = {
                customerId: self.calcRatesModel().customerId(),
                startDate: DateUtils.toIsoStringDate(self.calcRatesModel().startDate()),
                endDate: DateUtils.toIsoStringDate(self.calcRatesModel().endDate())
            };
            obj["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/Plan/CalculateRates",
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    $(modal).modal("hide");
                    return;
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        CustomerActions.prototype.openCustomerMap = function () {
            var self = this;
            var title = "Map Customers With Freshbooks";
            tools.editModal({
                title: title,
                buttonTitle: "Close",
                modalClass: "full-width",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    $(modal).modal("hide");
                },
                opened: function (modal) {
                    // Get lookup data:
                    tools.ajaxGet({
                        url: "/customers/getmaplookupdata",
                        success: function (data) {
                            if (data.Success) {
                                self.mapLookupLists = data.Data.lookupLists;
                                $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'customer-map-edit-template', data: $root }\"></div>");
                                ko.applyBindings(self, modal);
                                self.initCustomerMapGrid(self.mapLookupLists.GridStructures.CustomerMapStructure);
                            }
                            else {
                                log.error(data.Error);
                            }
                        }
                    });
                }
            });
        };
        CustomerActions.prototype.initCustomerMapGrid = function (gridStructure) {
            var self = this;
            var columns = gridStructure.columns;
            self.addEditActionColumn(columns);
            self.customerMapTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/Customers/GetCustomerMapRecords",
                            type: "POST",
                            data: function () {
                                var data = {};
                                return data;
                            },
                            dataType: "json"
                        },
                        update: {
                            url: "/Customers/UpdateExternalId/",
                            data: function () {
                                var data = {};
                                data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
                                return data;
                            },
                            dataType: "json",
                            type: "POST"
                        }
                    },
                    batch: false,
                    schema: {
                        model: gridStructure.model
                    },
                    error: function (e) {
                        console.log("error", e);
                        self.customerMapTable.getGridData().cancelChanges();
                    }
                },
                gridOptions: {
                    //toolbar: kendo.template($('#number-import-toolbar').html()),
                    height: 500,
                    columns: columns,
                    editable: {
                        mode: "inline"
                    } /*,
                    save: function (e) {
                        console.log("save",e);
                        //e.sender.saveChanges();
                    },
                    saveChanges: function (e) {
                        console.log("saveChanges", e);
                    },
                    cancel: function(e) {
                        console.log("cancel", e);
                    },
                    change: function (e) {
                        console.log("change", e);
                    },
                    edit: function (e) {
                        console.log("edit", e);
                    }*/
                },
                gridId: "customerMapTable"
            };
            self.customerMapTable.initGrid(gridOptions);
        };
        CustomerActions.prototype.addEditActionColumn = function (columns) {
            var actions = {
                field: "",
                command: ["edit"],
                width: "86px"
            };
            columns.push(actions);
            //check custom editor
            var customEditors = {};
            customEditors["FbNameEditor"] = function (container, options) {
                $('<input data-bind="value:' + options.field + '" name="' + options.field + '"/>')
                    .appendTo(container)
                    .kendoComboBox({
                    dataTextField: "Text",
                    dataValueField: "Id",
                    filter: "contains",
                    //autoBind: true,
                    minLength: 1,
                    dataSource: {
                        transport: {
                            read: {
                                url: "/Customers/FbClientRecords",
                                type: "POST",
                                data: function () {
                                    var data = {};
                                    data.externalId = options.model.ExternalId;
                                    return data;
                                },
                                dataType: "json"
                            }
                        },
                        schema: {
                            data: function (response) { return response.Data; },
                            total: "Total",
                            aggregates: "Aggregates",
                            errors: "Errors"
                        },
                        pageSize: 100,
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true
                    }
                }).data("kendoComboBox");
            };
            ko.utils.arrayForEach(columns, function (column) {
                if (column.hasOwnProperty("editor")) {
                    column["editor"] = customEditors[column["editor"]];
                }
            });
            return columns;
        };
        CustomerActions.prototype.bulkEditCustomers = function (customers) {
            var self = this;
            self.bulkEditCustomerModel(new BulkEditCustomerModel());
            var customerIds = ko.utils.arrayMap(customers, function (item) {
                return item.id;
            });
            self.bulkEditCustomerModel().Customers(customers);
            self.bulkEditCustomerModel().CustomersIds(customerIds);
            tools.editModal({
                title: "Customers Bulk Edit",
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    $(event.currentTarget).button("loading");
                    self.saveBulkEditCustomers(event.currentTarget, modal);
                },
                opened: function (modal) {
                    // Get lookup data:
                    var getLookupData = tools.ajaxGet({
                        url: urls_1.urls.customerGetLookupData,
                        data: { customerId: 0 },
                        success: function (data) {
                            if (data.Success) {
                                self.lookupLists = data.Data.lookupLists;
                            }
                            else {
                                log.error(data.Error);
                            }
                        }
                    });
                    $.when(getLookupData).done(function () {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'bulk-customer-edit-template', data: bulkEditCustomerModel }\"></div>");
                        ko.applyBindings(self, modal);
                    });
                }
            });
        };
        CustomerActions.prototype.saveBulkEditCustomers = function (btn, modal) {
            var self = this;
            var obj = ko.mapping.toJS(self.bulkEditCustomerModel);
            obj["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/Customers/SaveBulkEditCustomers",
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    if (self.saveCustomerCallback) {
                        self.saveCustomerCallback(result.Data);
                    }
                    $(modal).modal("hide");
                    return;
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        CustomerActions.prototype.bulkEditMembers = function (customers) {
            var self = this;
            self.bulkEditCustomerMemberModel(new BulkEditCustomerMemberModel());
            var customerIds = ko.utils.arrayMap(customers, function (item) {
                return item.id;
            });
            self.bulkEditCustomerMemberModel().Customers(customers);
            self.bulkEditCustomerMemberModel().CustomersIds(customerIds);
            tools.editModal({
                title: "Customers Members Bulk Edit",
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    self.bulkEditCustomerMemberModel().EmployeeId(self.employeesDropdown.value());
                    self.bulkEditCustomerMemberModel().EmployeeRoleId(self.employeeRolesDropdown.value());
                    self.bulkEditCustomerMemberModel().CommissionRoleId(self.commissionRolesDropdown.value());
                    if (!self.bulkEditCustomerMemberModel().EmployeeId()) {
                        tools.error("Member is a required field");
                        return;
                    }
                    if (!self.bulkEditCustomerMemberModel().EmployeeRoleId()) {
                        tools.error("Position is a required field");
                        return;
                    }
                    $(event.currentTarget).button("loading");
                    self.saveBulkEditMembers(event.currentTarget, modal);
                },
                opened: function (modal) {
                    // Get lookup data:
                    var getLookupData = tools.ajaxGet({
                        url: urls_1.urls.customerGetLookupData,
                        data: { customerId: 0 },
                        success: function (data) {
                            if (data.Success) {
                                self.lookupLists = data.Data.lookupLists;
                            }
                            else {
                                log.error(data.Error);
                            }
                        }
                    });
                    $.when(getLookupData).done(function () {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'customer-employee-bulk-edit-template', data: bulkEditCustomerMemberModel }\"></div>");
                        ko.applyBindings(self, modal);
                        var lookupDataSources = new LookupDataSources();
                        var employeesDS = lookupDataSources.createLookupDataSource("Employees");
                        var employeeRolesDS = lookupDataSources.createLookupDataSource("EmployeeRoles");
                        var commissionRolesDS = lookupDataSources.createLookupDataSource("EmployeeCommissionRoles");
                        self.employeesDropdown = $("input[name=EmployeeId]", modal).kendoDropDownList({
                            dataSource: employeesDS,
                            dataTextField: "Text",
                            dataValueField: "Id",
                            valuePrimitive: true,
                            filter: "contains",
                            popup: {
                                appendTo: $(".modal-body", modal)
                            }
                        }).data("kendoDropDownList");
                        self.employeeRolesDropdown = $("input[name=EmployeeRoleId]", modal).kendoDropDownList({
                            dataSource: employeeRolesDS,
                            dataTextField: "Text",
                            dataValueField: "Id",
                            valuePrimitive: true,
                            filter: "contains",
                            popup: {
                                appendTo: $(".modal-body", modal)
                            }
                        }).data("kendoDropDownList");
                        self.commissionRolesDropdown = $("input[name=CommissionRoleId]", modal).kendoDropDownList({
                            dataSource: commissionRolesDS,
                            cascadeFrom: "EmployeeId",
                            cascadeFromField: "EmployeeId",
                            dataTextField: "Text",
                            dataValueField: "Id",
                            valuePrimitive: true,
                            optionLabel: "Select Commissions Role",
                            filter: "contains",
                            popup: {
                                appendTo: $(".modal-body", modal)
                            }
                        }).data("kendoDropDownList");
                    });
                }
            });
        };
        CustomerActions.prototype.saveBulkEditMembers = function (btn, modal) {
            var self = this;
            var obj = ko.mapping.toJS(self.bulkEditCustomerMemberModel);
            obj["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/CustomerEmployees/SaveBulkEditMembers",
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    if (self.saveCustomerCallback) {
                        self.saveCustomerCallback(result.Data);
                    }
                    $(modal).modal("hide");
                    return;
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        return CustomerActions;
    }());
    return CustomerActions;
});
//# sourceMappingURL=customerActions.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/customers/customerActions.js
// module id = 70
// module chunks = 2